export const ATTENDANCE_STATUS_ORDER = ["hadir", "terlambat", "pulang_cepat", "sakit", "cuti", "izin"];

const KNOWN = new Set(ATTENDANCE_STATUS_ORDER);

export function countAttendanceByStatus(history) {
  const counts = { lainnya: 0, total: 0 };
  for (const status of ATTENDANCE_STATUS_ORDER) counts[status] = 0;
  for (const record of history || []) {
    const status = record?.status;
    if (typeof status === "string" && KNOWN.has(status)) {
      counts[status] += 1;
    } else {
      counts.lainnya += 1;
    }
    counts.total += 1;
  }
  const ordered = {};
  for (const status of ATTENDANCE_STATUS_ORDER) ordered[status] = counts[status];
  ordered.lainnya = counts.lainnya;
  ordered.total = counts.total;
  return ordered;
}
